<template>
    <div class="container" @scroll="handleScroll">
        <button class="sample-button back-button" @click="goBack">返回上一页</button>

        <h1>设备登录历史</h1>

        <button class="sample-button export-partial-button" @click="exportShowingTable"
            :disabled="isExporting">{{ isExporting ? "正在导出" : "导出当前内容" }}</button>
        <button class="sample-button export-full-button" @click="exportFullTable" :disabled="isExporting">{{ isExporting ?
            "正在导出" :"导出全部内容"}}</button>

        <div class="filters">
            <label for="device-id">设备 ID:</label>
            <input type="text" id="device-id" v-model="filters.device_id" @input="refreshContent" placeholder="输入设备 ID">

            <label for="start-time">存储记录创建开始时间:</label>
            <input type="datetime-local" id="start-time" v-model="filters.start_time" @change="refreshContent">

            <label for="end-time">存储记录创建结束时间:</label>
            <input type="datetime-local" id="end-time" v-model="filters.end_time" @change="refreshContent">

            <button class="sample-button" @click="refreshContentAndReset">刷新内容</button>
        </div>

        <table>
            <thead>
                <tr>
                    <th>ID</th>
                    <th>设备 ID</th>
                    <th>IP</th>
                    <th>设备登录的时间</th>
                    <th>纬度</th>
                    <th>经度</th>
                    <th>存储记录创建时间</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in loginHistory" :key="item.id">
                    <td>{{ item.id }}</td>
                    <td>{{ item.device_id }}</td>
                    <td>{{ item.ip }}</td>
                    <td>{{ item.timestamp }}</td>
                    <td>{{ item.latitude }}</td>
                    <td>{{ item.longitude }}</td>
                    <td>{{ item.created_at }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import axios from 'axios';
import { transformDate } from '../utils';
import * as XLSX from 'xlsx';

const axiosInstance = axios.create({
    baseURL: 'https://relia-server.com:3000',
    timeout: 10000,
    withCredentials: true
});

export default {
    name: 'DatabaseViewing',
    data() {
        return {
            loginHistory: [],
            filters: {
                device_id: '',
                start_time: '',
                end_time: ''
            },
            currentPage: 1,
            isLoading: false,
            hasMore: true,
            isExporting: false
        };
    },
    mounted() {
        this.fetchLoginHistory();
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        async fetchLoginHistory() {
            if (this.isLoading || !this.hasMore) return;

            this.isLoading = true;
            try {
                const params = {
                    ...this.filters,
                    page: this.currentPage,
                    count: 50
                };
                const response = await axiosInstance.get('/api/device_login_history', { params });
                const newItems = response.data.map((item) => transformDate(item));
                this.loginHistory = [...this.loginHistory, ...newItems];
                this.hasMore = newItems.length === 50;
                this.currentPage++;
            } catch (error) {
                console.error('Error fetching login history:', error);
            } finally {
                this.isLoading = false;
            }
        },
        refreshContentAndReset() {
            this.filters = {
                device_id: '',
                start_time: '',
                end_time: ''
            };
            this.refreshContent();
        },
        refreshContent() {
            this.loginHistory = [];
            this.currentPage = 1;
            this.hasMore = true;
            this.fetchLoginHistory();
        },
        goBack() {
            this.$router.go(-1);
        },
        async exportShowingTable() {
            if (this.isExporting) return;
            this.isExporting = true;

            try {
                const headers = ['ID', '设备 ID', 'IP', '设备登录的时间', '纬度', '经度', '存储记录创建时间'];
                const rows = this.loginHistory.map(item => [
                    item.id,
                    item.device_id,
                    item.ip,
                    item.timestamp,
                    item.latitude,
                    item.longitude,
                    item.created_at
                ]);

                const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, '设备登录历史');
                XLSX.writeFile(workbook, 'device_login_history.xlsx');
            } catch (error) {
                console.error('Error exporting login history:', error);
                alert(`导出失败，原因：${error.message}`);
            } finally {
                this.isExporting = false;
            }
        },
        async exportFullTable() {
            if (this.isExporting) return;
            this.isExporting = true;

            try {
                const params = {
                    ...this.filters,
                    page: 1,
                    count: -1
                };
                const response = await axiosInstance.get('/api/device_login_history', { params });
                const allitems = response.data.map((item) => transformDate(item));

                const headers = ['ID', '设备 ID', 'IP', '设备登录的时间', '纬度', '经度', '存储记录创建时间'];
                const rows = allitems.map(item => [
                    item.id,
                    item.device_id,
                    item.ip,
                    item.timestamp,
                    item.latitude,
                    item.longitude,
                    item.created_at
                ]);

                const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, '设备登录历史');
                XLSX.writeFile(workbook, 'device_login_history.xlsx');
            } catch (error) {
                console.error('Error fetching login history:', error);
                alert(`导出失败，原因：${error.message}`);
            } finally {
                this.isExporting = false;
            }
        },
        handleScroll() {
            const bottom = document.documentElement.scrollHeight - document.documentElement.scrollTop - document.documentElement.clientHeight;
            if (bottom < 50) {
                console.log('Reached the bottom of the page');
                this.fetchLoginHistory();
            }
        }
    }
}
</script>

<style scoped>
.container {
    text-align: center;
    margin: 0 auto;
    max-width: 1200px;
    position: relative;
    overflow-y: auto;
}

.filters {
    margin-bottom: 20px;
}

.filters label {
    margin-right: 10px;
}

.filters input {
    margin-right: 20px;
    padding: 5px;
}

/* 设置表头固定 */
th {
    background-color: #3a3e6b;
    text-align: center;
    color: #ffffff;
    /* 设置表头字体颜色 */
    position: sticky;
    top: 0;
    z-index: 1;
    /* 确保表头位于内容的上层 */
}

/* 其余样式保持不变 */
table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
}

/* 框的样式 */
th,
td {
    border: 2px solid #ddd;
    padding: 10px;
}

/* 表头样式 */
th {
    background-color: #3a3e6b;
    text-align: center;
    color: #ffffff;
    /* 设置表头字体颜色 */
}

/* 普通单元格样式 */
td {
    text-align: center;
}

/* 设置奇数和偶数行不同的背景色 */
tbody tr:nth-child(odd) {
    background-color: #ececec;
    /* 偶数行背景色 */
}

tbody tr:nth-child(even) {
    background-color: #ffffff;
    /* 奇数行背景色 */
}

/* 设置ID列加粗并改变颜色 */
tbody tr td:nth-child(1) {
    font-weight: bold;
}

/* 外框样式 */
table {
    width: 100%;
    border: 4px solid #3a3e6b;
    /* 设置外框的边框 */
}

.sample-button {
    padding: 10px 20px;
    background-color: #3a3e6b;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

.sample-button:hover {
    background-color: #2a2e5b;
}

.back-button {
    position: absolute;
    top: 20px;
    left: 20px;
}

.export-partial-button {
    position: absolute;
    top: 20px;
    right: 160px;
}

.export-full-button {
    position: absolute;
    top: 20px;
    right: 20px;
}

.sample-button:disabled {
    background-color: #cccccc;
    color: #666666;
    cursor: not-allowed;
}

</style>
